import {
  getSelectedDeliveryOptionList,
} from '../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import getProductIdForGTM from './getProductIdForGTM';
import getCategoriesFromProduct from './getCategoriesFromProduct';
import getProductVariantIdForGTM from './getProductVariantIdForGTM';

export default (getState) => {
  if (!window.dataLayer?.push) return 'fail';
  
  const {start} = window;
  const {order} = start;
  
  const selectedDeliveryTypes = getSelectedDeliveryOptionList(getState);
  const multipleDeliveryTypes = selectedDeliveryTypes.length > 1;
  
  function findDeliveryNames() {
    let deliveryNames = '';
    if (!multipleDeliveryTypes) {
      deliveryNames = deliveryNames.concat(selectedDeliveryTypes[0].type);
    } else {
      let firstDeliveryType = true;
      selectedDeliveryTypes.forEach((deliveryType) => {
        if (firstDeliveryType) {
          deliveryNames = deliveryNames.concat(deliveryType.type);
          firstDeliveryType = false;
        } else {
          deliveryNames = deliveryNames.concat(' & ', deliveryType.type);
        }
      });
    }
    return deliveryNames;
  }
  
  window.dataLayer.push({
    event: 'add_shipping_info',
    ecommerce: {
      currency: start.orderTotal?.currencyCode || '',
      value: start.orderTotal?.value,
      coupon: start.order?.discountCode || '',
      shipping_tier: findDeliveryNames(),
      items: order.basketItems?.map(basketItem => ({
        item_id: getProductIdForGTM(basketItem),
        ...getCategoriesFromProduct(basketItem),
        item_name: basketItem?.productTitle,
        item_brand: basketItem?.brand,
        item_variant: getProductVariantIdForGTM(basketItem),
        price: basketItem?.chargePricePerUnit?.value,
        quantity: basketItem?.quantity,
      })),
    },
  });
  return 'success';
};
